import { Plus } from 'lucide-react';
import Fab from './Fab';

/**
 * The legacy "New +" floating action button (extended Fab, primary, medium) parked at the
 * bottom-right of the list pages above the bottom navigation. `bottom` is the per-page offset
 * (100px on the Equipment and Calibration Due Dates lists, ...).
 */
const NewFab = ({
  onClick,
  bottom = 100,
  label = 'New',
}: {
  onClick: () => void;
  bottom?: number;
  label?: string;
}) => (
  <Fab ariaLabel={label} bottom={bottom} onClick={onClick}>
    {label} <Plus className='rep:ml-1.5 rep:size-6' />
  </Fab>
);

export default NewFab;
